import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=0061892a&scoped=true"
import script from "./reject.vue?vue&type=script&lang=js"
export * from "./reject.vue?vue&type=script&lang=js"
import style0 from "./reject.vue?vue&type=style&index=0&id=0061892a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061892a",
  null
  
)

export default component.exports